import { DeliveryMethodType, ORDER_STATUSES } from 'src/consts';

import styles from './styles.module.scss';

interface StatusIconProps {
  orderStatus: string;
  deliveryMethodType: DeliveryMethodType;
}

const OrderStatusIconMap = {
  [ORDER_STATUSES.received]: '/public/received.svg',
  [ORDER_STATUSES.processing]: '/public/processing.svg',
  [ORDER_STATUSES.delivered]: '/public/delivered.svg',
  [ORDER_STATUSES.preparing]: '/public/preparing.svg',
  [ORDER_STATUSES.packed]: '/public/preparing.svg',
  [ORDER_STATUSES.shipped]: '/public/mail-order-shipped.svg',
};

const OrderStatusPickupStationIconMap = {
  ...OrderStatusIconMap,
  [ORDER_STATUSES.delivered]: '/public/pickup_station.svg',
};

const OrderStatusMailIconMap = {
  [ORDER_STATUSES.received]: '/public/mail-order-received.svg',
  [ORDER_STATUSES.processing]: '/public/mail-order-processing.svg',
  [ORDER_STATUSES.delivered]: '/public/delivered.svg',
  [ORDER_STATUSES.preparing]: '/public/mail-order-processing.svg',
  [ORDER_STATUSES.packed]: '/public/mail-order-processing.svg',
  [ORDER_STATUSES.shipped]: '/public/mail-order-shipped.svg',
};

export const getStatusIcon = (orderStatus, deliveryMethodType) => {
  if (deliveryMethodType === DeliveryMethodType.mail) {
    return OrderStatusMailIconMap[orderStatus];
  } else if (deliveryMethodType === DeliveryMethodType.pickupStation) {
    return OrderStatusPickupStationIconMap[orderStatus];
  } else {
    return OrderStatusIconMap[orderStatus];
  }
};

export const StatusIcon = ({ orderStatus = ORDER_STATUSES.delivered, deliveryMethodType }: StatusIconProps) => {
  const statusIcon = getStatusIcon(orderStatus, deliveryMethodType);
  if (!statusIcon) return null;
  return (
    <div className={styles.svgContainer}>
      <img className={styles.icon} src={statusIcon} alt="" />
    </div>
  );
};
